export default __webpack_public_path__ + "static/media/localtext.b1050750.csv";